import type { ReactElement } from 'react';
import type { TeilnehmerVeranstaltung } from '@mcikm-vote/shared';

import { Karte } from '../../../components/Karte';
import { formatiereDatum } from '../../../formatierung';

/**
 * Veranstaltung beendet (§6.2, §19.2).
 *
 * Abschlussmeldung mit Bezeichnung und Datum. Weitere Abstimmungen gibt es nicht; die Sitzungen
 * wurden serverseitig bereits ungültig gesetzt (§6.2), sodass diese Ansicht in aller Regel nur
 * kurz erscheint, bevor die Anmeldeseite folgt.
 */
export function VeranstaltungBeendetAnsicht({
  veranstaltung,
}: {
  veranstaltung: TeilnehmerVeranstaltung;
}): ReactElement {
  return (
    <Karte className="text-center">
      <h2 className="text-xl font-semibold">{veranstaltung.bezeichnung}</h2>
      <p className="text-text-gedaempft mt-1 text-sm">
        {formatiereDatum(veranstaltung.veranstaltungsdatum)}
      </p>

      <p className="mt-4 text-lg font-medium">Die Veranstaltung ist beendet.</p>
      <p className="text-text-gedaempft mt-2 text-sm">
        Es finden keine weiteren Abstimmungen statt. Vielen Dank für Ihre Teilnahme.
      </p>
    </Karte>
  );
}
